const e=e=>e;export{e as defineFlag};
//# sourceMappingURL=define-flag.mjs.map